import { CapoPlugin } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];